import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import CreateModule from "@components/modules/expenses/Create";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { NavigationExpense } from "@src/components/widgets/AppSubNav/navigation-expense";
import { useStore } from "@src/utils/hooks";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const Page = ({ id }: WithIdProps) => {
  const { UIStore } = useStore();

  useEffect(() => {
    return () => {
      UIStore.onBackButtonClick = undefined;
    };
  }, []);

  return (
    <MainLayout
      title={t`Edit expense`}
      navigation={<NavigationExpense expenseId={id} />}
    >
      <CreateModule.Edit id={id} />
    </MainLayout>
  );
};

const RouteComponent = withId(Page);

export const Route = createFileRoute("/expenses/edit")({
  component: RouteComponent,
});
